export default "__VITE_ASSET__7a483a15__"